// extracted by mini-css-extract-plugin
export default {"navigation":"NavigationArrows__navigation--slots-HKk2K","item":"NavigationArrows__item--slots-iZXs0"};